import { render, staticRenderFns } from "./Canjes.vue?vue&type=template&id=8734daf2&scoped=true"
import script from "./Canjes.vue?vue&type=script&lang=js"
export * from "./Canjes.vue?vue&type=script&lang=js"
import style0 from "./Canjes.vue?vue&type=style&index=0&id=8734daf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8734daf2",
  null
  
)

export default component.exports